import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"

import { logger } from "@/core/logger.server"

import { createSupabaseServerClient } from "../supabase.server"

// Scope local: sign out this browser only. The default (global) would also sign out the phone, which conflicts with
// the signed-in devices page; "Sign out of all devices" revokes every session through DELETE /api/v1/sessions?scope=all
// before it calls this.
export const logout = createServerFn({ method: "POST" }).handler(async () => {
  const { error } = await createSupabaseServerClient().auth.signOut({ scope: "local" })
  if (error) {
    logger.error("auth.logout.failed", { error })
    throw new Error("Logout failed, please try again", { cause: error })
  }
  throw redirect({ to: "/" })
})
